module.exports = __webpack_public_path__ + "img/base_hebergements_aire_camping_car.ed0b4dbf.svg";